import { useQuery } from '@apollo/client';

import { GET_USER_TWILIO_STATE } from '../data/queries/getUserTwilioState.gql';

export interface TwilioStateData {
  status?: string;
  __typename: string;
  message?: string;
  responseType?: string;
  ErrorMessage?: string;
  invalidFields?: Array<{
    fieldName: string;
    reason: string;
    __typename: string;
  }>;
}

export interface UseGetUserTwilioStateResult {
  twilioState: TwilioStateData | null;
  loading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useGetUserTwilioState = (
  userId?: string
): UseGetUserTwilioStateResult => {
  const { data, loading, error, refetch } = useQuery(GET_USER_TWILIO_STATE, {
    variables: { id: userId },
    skip: !userId,
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  return {
    twilioState: data?.userTwilioState || null,
    loading,
    error: error || null,
    refetch,
  };
};
